export const fetchData = (url) => {
  return fetch(url);
};
